var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edito"},[_c('ui-wip',[_c('div',{staticClass:"big-title"},[_vm._v("WIP Edito Page")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }